import SuggestionItemApiModel from './suggestion-item.api-model';

export default class EpiserverFindSuggestionApiModel {
  public static mapToBusinessModel(apiModel: EpiserverFindSuggestionApiModel): string[] {
    return apiModel.hits.map((h) => SuggestionItemApiModel.mapToBusinessModel(h));
  }

  public status!: string;
  public hits!: SuggestionItemApiModel[];
}
